export var PhoneNumberType;
(function(PhoneNumberType) {
    PhoneNumberType[/**
     * A home phone number.
     */ "Home"] = "Home";
    PhoneNumberType[/**
     * A mobile phone number.
     */ "Mobile"] = "Mobile";
    PhoneNumberType[/**
     * A work phone number.
     */ "Work"] = "Work";
    PhoneNumberType[/**
     * A business phone number.
     */ "Business"] = "Business";
    PhoneNumberType[/**
     * A fax number.
     */ "Fax"] = "Fax";
})(PhoneNumberType || (PhoneNumberType = {}));

//# sourceMappingURL=phone-number-type.js.map